import * as React from 'react';
import { Carousel, Embla } from '@mantine/carousel';
import { ActionIcon, Group, createStyles, Box, Text, useMantineTheme } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconUser } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

// Components
import { ContactForm } from '../ContactForm';
import { hydrateManifestSection } from '../Form/helpers/hydrateManifestSection';

// Types
import { IManifestFieldHydrated } from '../../manifests/types';
import { IContactRecord } from '../../types';

const useStyles = createStyles((theme) => ({
    wrapper: {
        marginRight: '-1.25rem !important',
        marginLeft: '-1.25rem !important',
        maxWidth: 'calc(100% + 2.5rem)'
    },
    container: {
        // marginRight: '-1.25rem !important',
        // marginLeft: '-1.25rem !important'
    },
    slide: {
        overflow: 'hidden'
    },
    header: {
        borderTop: '1px solid #dee2e6',
        borderBottom: '1px solid #dee2e6',
        // marginRight: '-1.25rem !important',
        // marginLeft: '-1.25rem !important',
        padding: '0.5rem 1.25rem',
        // background: theme.colors.indigo[0],
        // color: theme.colors.indigo[8],
        // color: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color,
        // background: '#fcfdff',
        // color: theme.colors.orange[6],
        // background: theme.colors.orange[0],
        background: '#f9fcff',
        color: theme.colors.blue[8],
        paddingLeft: '10px'
    }
}));

interface ConfirmContactsModuleProps<FormValues> {
    data?: IContactRecord[];
    subManifest: IManifestFieldHydrated[];
    parentform: UseFormReturnType<FormValues>;
    parentNext?: () => Promise<void>;
    parentPrev?: () => void;
    activeStep?: number;
    surveyId?: string;
    clientId?: string;
    trigger?: string;
}

export function ConfirmContactsModule<
    FormValues extends {
        contactsModule?: any[];
    }
>(props: ConfirmContactsModuleProps<FormValues>) {
    const theme = useMantineTheme();
    const { t } = useTranslation();
    const { classes, cx } = useStyles();
    const { data, subManifest, parentNext, parentPrev, activeStep, surveyId, clientId, trigger } = props;
    const [embla, setEmbla] = React.useState<Embla | null>(null);
    const formProps = React.useMemo(
        () => ({
            isSubForm: true,
            hideCancel: true,
            dirtySaveOnly: false,
            saveLabelKey: 'saveContinue',
            manifestSections: [{ manifest: hydrateManifestSection(subManifest) }],
            formInsert: true,
            drawerCard: false,
            confirmContact: true,
            surveyId,
            clientId,
            trigger
        }),
        [subManifest, surveyId, hydrateManifestSection, trigger]
    );
    const [currentSlide, setCurrentSlide] = React.useState(1);
    const nextSlide = React.useCallback(() => {
        if (embla?.scrollNext && embla?.canScrollNext?.()) {
            embla.scrollNext();
            setCurrentSlide(currentSlide + 1);
        }
    }, [embla, setCurrentSlide, currentSlide]);
    const prevSlide = React.useCallback(() => {
        if (embla?.scrollPrev && embla?.canScrollPrev?.()) {
            embla.scrollPrev();
            setCurrentSlide(currentSlide - 1);
        }
    }, [embla, setCurrentSlide, currentSlide]);

    return (
        <Box className={classes.wrapper}>
            <Group position="apart" className={classes.header}>
                <Group style={{ gap: 0 }}>
                    <ActionIcon
                        variant={'transparent'}
                        color={'blue'}
                        // color={theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color}
                        style={{ cursor: 'default' }}
                    >
                        <IconUser size={16} />
                    </ActionIcon>
                    <Text size="md" fw={500}>
                        {data?.[currentSlide - 1]?.name?.fullName ?? ''}
                    </Text>
                </Group>
                {data?.length && data?.length > 1 ? (
                    <Text size="sm" fw={500}>
                        {currentSlide} / {data.length}
                    </Text>
                ) : null}
            </Group>
            <Box className={classes.container}>
                {data?.length && data.length > 1 ? (
                    <Carousel
                        align={'start'}
                        draggable={false}
                        getEmblaApi={setEmbla}
                        withIndicators={false}
                        withControls={false}
                        classNames={{
                            slide: classes.slide
                        }}
                    >
                        {data.map((contact, index) => (
                            <Carousel.Slide key={index}>
                                <ContactForm
                                    contactId={contact?.id}
                                    {...formProps}
                                    onSave={() => {
                                        if (index < data.length - 1) {
                                            nextSlide();
                                        } else {
                                            parentNext?.();
                                        }
                                    }}
                                    parentPrev={index === 0 ? parentPrev : prevSlide}
                                />
                            </Carousel.Slide>
                        ))}
                    </Carousel>
                ) : (
                    <ContactForm
                        contactId={data?.[0]?.id}
                        isNew={typeof data?.[0]?.id === 'undefined'}
                        {...formProps}
                        onSave={() => {
                            parentNext?.();
                        }}
                        parentPrev={parentPrev}
                    />
                )}
                {/* {data?.length && data.length === 1 ? (
                    <ContactForm
                        contactId={data?.[0]?.id}
                        {...formProps}
                        onSave={async (values: Record<string, any>) => {
                            try {
                                await onSave({ contactId: data?.[0]?.id, values });
                                parentNext?.();
                            } catch (e) {
                                console.log('Error saving contact data', e);
                            }
                        }}
                        parentPrev={parentPrev}
                    />
                ) : null} */}
            </Box>
        </Box>
    );
}
